import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { Qos as QosEvent, IQosStartSchema, IQosEndSchema } from '@ms/telemetry-manager/lib/events/Qos.event';
import { getTelemetryManager } from './telemetry/getTelemetryManager';

/**
 * Uses logger provided in the configuration, if any, to log quality of service ('QoS') events.
 * Returns a callback to use upon event end.
 * @public
 */
export function logQoS(startData: IQosStartSchema): IItemCacheThunkAction<(endData: IQosEndSchema) => IItemCacheThunkAction<void>> {
    return (dispatch: IItemCacheDispatch) => {
        const manager = dispatch(getTelemetryManager);

        const qos = new (QosEvent.withManager(manager))(startData);

        return (endData: IQosEndSchema) => {
            return (endDispatch: IItemCacheDispatch) => {
                qos.end(endData);
            };
        };
    };
}
